import React from 'react';
import {
  Box,
  TextField,
  MenuItem,
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

const InventoryFilters = ({
  statusFilter,
  onStatusFilterChange,
  selectedChannelId,
  onSelectChannel,
  availableChannels,
}) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          color: 'text.secondary',
          fontSize: '0.875rem',
          fontWeight: 600,
        }}
      >
        <FilterAltIcon sx={{ fontSize: 18 }} />
        Filters
      </Box>

      <TextField
        select
        id="status-filter"
        name="statusFilter"
        size="small"
        value={statusFilter}
        onChange={(e) => onStatusFilterChange(e.target.value)}
        sx={{ minWidth: 160 }}
      >
        <MenuItem value="active">Available Items</MenuItem>
        <MenuItem value="sold">Sold Items</MenuItem>
        <MenuItem value="missing">Missing Items</MenuItem>
      </TextField>

      <TextField
        select
        id="sales-channel-filter"
        name="salesChannelFilter"
        size="small"
        value={selectedChannelId || ''}
        onChange={(e) => onSelectChannel(e.target.value)}
        sx={{
          minWidth: 180,
        }}
        SelectProps={{
          displayEmpty: true,
        }}
      >
        <MenuItem value="">All Channels</MenuItem>
        {availableChannels.map(channel => (
          <MenuItem key={channel.id} value={channel.id}>{channel.name}</MenuItem>
        ))}
      </TextField>
    </>
  );
};

export default React.memo(InventoryFilters);
